export type QuestReasonLabelGlyphKind =
    | 'mention'
    | 'reply'
    | 'upvalue'
    | 'follow'
    | 'stream'
    | 'filter'

const MESSAGE_GLYPH_KINDS: Record<string, QuestReasonLabelGlyphKind> = {
    mention: 'mention',
    answer: 'reply',
    subquest: 'reply',
    subquest_answer: 'reply',
    following_bc_answer: 'reply',
    following_bc_mention: 'reply',
    answer_upvalue: 'upvalue',
    answer_vote: 'upvalue',
    quest_vote: 'upvalue',
    quest_crypto_vote: 'upvalue',
    answer_crypto_vote: 'upvalue',
    follow: 'follow',
    stream_message: 'stream',
    stream_invite: 'stream',
    stream_invite_accepted: 'stream',
    host_invite: 'stream',
    host_revenue: 'upvalue',
}

const LABEL_GLYPH_KINDS: Array<{
    pattern: RegExp
    kind: QuestReasonLabelGlyphKind
}> = [
    { pattern: /mentioned you/i, kind: 'mention' },
    // A stream notification can say "replied", so it must precede the generic reply pattern.
    { pattern: /(?:stream|channel) you're following/i, kind: 'stream' },
    { pattern: /replied/i, kind: 'reply' },
    { pattern: /upvalued|upvoted|rewarded/i, kind: 'upvalue' },
    { pattern: /started following you/i, kind: 'follow' },
    { pattern: /matches your .* filter/i, kind: 'filter' },
]

export function getQuestReasonLabelGlyphKind(
    label: string,
    notificationMessage?: string | null,
): QuestReasonLabelGlyphKind | null {
    const messageKind = notificationMessage
        ? MESSAGE_GLYPH_KINDS[notificationMessage.toLowerCase()]
        : null
    if (messageKind) return messageKind

    return LABEL_GLYPH_KINDS.find(({ pattern }) => pattern.test(label))?.kind || null
}
